import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
//import cartSliceReducer from "./slices/cartSlice";
import authSlice from "./slices/authSlice";
import newOrdersSlice from "./slices/newOrdersSlice";
// import userSlice from "./slices/userSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    // cart: cartSliceReducer,
    auth: authSlice,
    newOrders: newOrdersSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;
